/**
 * PDP Vertical Thumbnail Rail — desktop only.
 * Wires Dawn's slider-buttons to scroll the thumbnail <ul> vertically, and
 * toggles prev/next visibility based on scroll position.
 */
(function () {
  var DESKTOP_MQ = window.matchMedia('(min-width: 750px)');
  var SCROLL_STEP_RATIO = 0.9; // scroll 90% of the visible height per click

  function init(slider) {
    if (!DESKTOP_MQ.matches) return;
    if (slider.dataset.verticalRailInit === 'true') return;
    slider.dataset.verticalRailInit = 'true';

    var list = slider.querySelector('.thumbnail-list');
    if (!list) return;

    var prev = slider.querySelector('.slider-button--prev');
    var next = slider.querySelector('.slider-button--next');

    function updateButtons() {
      var overflowing = list.scrollHeight - list.clientHeight > 1;
      var atTop = list.scrollTop <= 1;
      var atBottom = list.scrollTop + list.clientHeight >= list.scrollHeight - 1;

      if (prev) prev.hidden = !overflowing || atTop;
      if (next) next.hidden = !overflowing || atBottom;
    }

    function scrollBy(direction) {
      var step = Math.max(list.clientHeight * SCROLL_STEP_RATIO, 100);
      list.scrollBy({ top: direction * step, behavior: 'smooth' });
    }

    if (prev) {
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        scrollBy(-1);
      });
    }
    if (next) {
      next.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        scrollBy(1);
      });
    }

    list.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);

    // Observe image loads — scrollHeight changes as thumbnails load.
    var imgs = list.querySelectorAll('img');
    imgs.forEach(function (img) {
      if (!img.complete) img.addEventListener('load', updateButtons, { once: true });
    });

    updateButtons();
  }

  function bootstrap() {
    document.querySelectorAll('.thumbnail-slider').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
